import type { RumInitConfiguration } from "@datadog/browser-rum";

/** One entry for `datadogRum.init({ allowedTracingUrls })`. */
export type RumAllowedTracingUrl = NonNullable<RumInitConfiguration["allowedTracingUrls"]>[number];

/** Propagators for RUM → backend APM (Datadog + W3C for OpenTelemetry/.NET). */
export const RUM_APM_PROPAGATOR_TYPES = ["datadog", "tracecontext"] as const;

export function isSameOriginBffApiUrl(url: string): boolean {
  if (typeof url !== "string" || !url.includes("/api/")) {
    return false;
  }

  try {
    const parsed = new URL(url, typeof window !== "undefined" ? window.location.origin : "http://localhost");
    if (typeof window !== "undefined" && parsed.origin !== window.location.origin) {
      return false;
    }
    return parsed.pathname.startsWith("/api/");
  } catch {
    return false;
  }
}

export function getRumAllowedTracingUrls(): RumAllowedTracingUrl[] {
  return [
    {
      match: isSameOriginBffApiUrl,
      propagatorTypes: [...RUM_APM_PROPAGATOR_TYPES],
    },
  ];
}
